import React from 'react';
import { Select } from 'antd';
import { formConfig, modes } from '../../../../config';
import { pathSegments, useWorkers } from '../../../../api/queries/useWorkers';
import { dspxGetWorkerChildrens } from '../../../../../../../../helpers/dspx-utils';
import FormItem from '../FormItem/FormItem';
import { getInitValForWorkersField } from '../../utils';

const isWarrantyParams = {
  [modes.regularToPossWarranty]: true,
  [modes.possWarrantyToRegular]: false,
  [modes.warrantyToRegular]: false,
};

const { fieldNames } = formConfig;

const SelectMasterField = ({ form, request, mode }) => {
  const { houseId, serviceId, master } = request;

  const { data, isFetching } = useWorkers(
    {
      pathSegment: pathSegments.masters,
      houseId,
      serviceId,
      isWarranty: isWarrantyParams[mode],
    },
    { staleTime: Infinity, enabled: Boolean(request) }
  );

  const initialValue = data?.length
    ? getInitValForWorkersField({ entities: data, entity: master })
    : undefined;

  return (
    <FormItem label="Мастер">
      {form.getFieldDecorator(fieldNames.master, {
        initialValue,
      })(
        <Select
          showSearch
          allowClear
          placeholder="Выберите мастера"
          optionFilterProp="searchtext"
          loading={isFetching}
          optionLabelProp="label"
        >
          {dspxGetWorkerChildrens(data, undefined, true)}
        </Select>
      )}
    </FormItem>
  );
};

export default SelectMasterField;
